import { useEffect, useRef } from "react";
import useUiContext from "@/custolink-hooks/useUiContext";
import ChatView, {
  ChatServerResponse,
} from "@/custolink-views/asset_frontend/asset_view/asset_components/ai_support/components/ChatView";
import GetPath from "@/custolink-logic/api/GetPath";
import { FrontendFilesApi as FrontendFilesApiGeneric }
  from "@/custolink-transpiled_by_server/bc.asset_files.api_generic";
import { AssetViewDetails } from "@/custolink-views/asset_frontend/asset_view/useAssetViewFacade";
import useChatStreamSend from "@/custolink-views/asset_frontend/asset_view/asset_components/ai_support/hooks/useChatStreamSend";

export default function AiSupportComponent(p:{
  assetViewDetails: AssetViewDetails
  /** Sent as the first question when the chat opens (e.g. from the asset page search). */
  initialQuestion?: string
}) {
  const uic = useUiContext()

  const getDownloadHref = (fileId: number) =>
    FrontendFilesApiGeneric.downloadFile(
      GetPath,
      uic._orgId,
      p.assetViewDetails.urlParamsForRequests.viewId,
      p.assetViewDetails.urlParamsForRequests.viewValue,
      p.assetViewDetails.urlParamsForRequests.assetId,
      fileId,
    );

  const { handleSend: handleStreamSend } = useChatStreamSend(
    uic._orgId,
    p.assetViewDetails.urlParamsForRequests.viewId,
    p.assetViewDetails.urlParamsForRequests.viewValue,
    p.assetViewDetails.urlParamsForRequests.assetId,
    getDownloadHref,
  );

  // Once per mount; the ref keeps StrictMode's double effect from sending twice.
  const sentInitial = useRef(false);
  useEffect(() => {
    const question = p.initialQuestion?.trim();
    if (question && !sentInitial.current) {
      sentInitial.current = true;
      void handleStreamSend(question);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [p.initialQuestion]);

  return (
    <div className="h-full">
      <ChatView
        chatPrompt={async () => {
          // streaming path: handleStreamSend manages the store directly;
          // returning an empty sentinel here since ChatView won't push the message itself
          return { response: "", contextFiles: [] } as ChatServerResponse;
        }}
        handleSendOverride={handleStreamSend}
      />
    </div>
  );
}
